<template>
  <div>
    <div class="container lnb d_container">
      <div class="contents_wrap">
        <div class="contents list-container">
          <div class="title">Korean Practice 관리
            <el-button class="title_btn" @click="moveCreate" type="primary">등록</el-button>
            <div class="clear"></div>
          </div>
          <div class="list-content content tab-content pb0">
            <div class="intro_tab " @click="changeTab('language')">Korean Practice 관리</div>
            <div class="intro_tab " @click="changeTab('topic')">Situation & Expression 관리</div>
            <div class="intro_tab" @click="changeTab('category')">Situation & Expression : Field 관리</div>
            <div class="intro_tab active" @click="changeTab('expression')">Level 관리</div>
            <div class="intro_tab" @click="changeTab('categoryExpression')">Level : Field 관리</div>
          </div>
          <div class="list-content">
              <topic-list-component :topic-type="'expression'"></topic-list-component>
          </div>
        </div>
        <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
      </div>
    </div>
  </div>
</template>

<script>
import TopicListComponent from "@/components/topic/TopicListComponent";
export default {
  name: "Expression",
  mixins: [],
  components: {
    TopicListComponent
  },
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    changeTab(tab) {
      this.$router.push(`/content/${tab}`);
      this.$nextTick(() => {
        this.$router.push(`/content/${tab}`);
      })
    },
    moveCreate(){
      this.$router.push('/content/expression/create');
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>